import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

type Props = {
	path: string;
	children: React.ReactNode
}

const ProtectedRoute = ({ path, children }: Props): any => {
	const data = useSelector((state: any) => state.auth);

	if (path === 'switch-account' && !data.isLoggedIn) {
		return <Navigate to='/auth' />
	}
	if (path == 'verification' && !data.needsVerification) {
		return <Navigate to='/auth' />
	}
	return children
}

export default ProtectedRoute